var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods_nav_inner" }, [
    _vm.value.config.is_show_title === 1
      ? _c(
          "div",
          { staticClass: "tabs" },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              _vm._l(_vm.tabList, function (item) {
                return _c(
                  "el-tab-pane",
                  { key: item.id, attrs: { name: item.id } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("div", [_vm._v(" " + _vm._s(item.name) + " ")]),
                      item.sub_name && _vm.value.config.is_open_sub_name === "1"
                        ? _c("div", { staticClass: "sub_name" }, [
                            _vm._v(" " + _vm._s(item.sub_name) + " "),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.value.config.show_type === 2
      ? _c(
          "div",
          { staticClass: "box2" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c("div", {
                staticClass: "pic",
                style: { backgroundImage: "url(" + item.goods_thumb + ")" },
              }),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.goods_name)),
                  ]),
                  _c("div", { staticClass: "inventory" }, [
                    _vm._v(" 库存: 900 "),
                  ]),
                ]),
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticClass: "num" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("moneyFormat")(item.shop_price)) + " "
                    ),
                  ]),
                  _vm._v(" 点 "),
                ]),
              ]),
            ])
          }),
          0
        )
      : _vm.value.config.show_type === 4
      ? _c(
          "div",
          { staticClass: "box4" },
          _vm._l(_vm.goodsList, function (item, index) {
            return _c("div", { key: index, staticClass: "item" }, [
              _c("div", {
                staticClass: "pic",
                style: { backgroundImage: "url(" + item.goods_thumb + ")" },
              }),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.goods_name)),
                  ]),
                  _c("div", { staticClass: "inventory" }, [
                    _vm._v(" 库存: 900 "),
                  ]),
                ]),
                _c("div", { staticClass: "price-bar" }, [
                  _c("div", { staticClass: "price" }, [
                    _c("span", { staticClass: "num" }, [
                      _c("span", { staticClass: "int" }, [
                        _vm._v(_vm._s(_vm.splitPrice(item.shop_price).int)),
                      ]),
                      _vm.splitPrice(item.shop_price).dec
                        ? _c("span", { staticClass: "decimal" }, [
                            _vm._v(
                              "." + _vm._s(_vm.splitPrice(item.shop_price).dec)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "middle-tag" },
                    _vm._l(
                      _vm.middleTagLines(index),
                      function (line, lineIndex) {
                        return _c(
                          "div",
                          { key: lineIndex, class: ["tag-line", line.cls] },
                          [
                            line.parts
                              ? [
                                  _c("span", { staticClass: "int" }, [
                                    _vm._v(_vm._s(line.parts.int)),
                                  ]),
                                  line.parts.dec
                                    ? _c("span", { staticClass: "decimal" }, [
                                        _vm._v("." + _vm._s(line.parts.dec)),
                                      ])
                                    : _vm._e(),
                                ]
                              : [_vm._v(_vm._s(line.text))],
                          ],
                          2
                        )
                      }
                    ),
                    0
                  ),
                  _c("div", { staticClass: "btn" }, [
                    _vm._v(
                      " " + _vm._s(_vm.tagConfig.tag_btn_text || "抢") + " "
                    ),
                  ]),
                ]),
              ]),
            ])
          }),
          0
        )
      : _c(
          "div",
          { class: ["box" + (_vm.value.config.show_type || 1), "clearfix"] },
          [
            _vm.value.config.is_open_ad === "1" &&
            Array.isArray(_vm.value.config.ads)
              ? _vm._l(_vm.value.config.ads, function (item, adIndex) {
                  return _c(
                    "div",
                    { key: adIndex + "_ad", staticClass: "item ad" },
                    [
                      _c("el-image", {
                        staticStyle: { width: "100%" },
                        attrs: { src: item.imageurl },
                      }),
                    ],
                    1
                  )
                })
              : _vm._e(),
            _vm._l(_vm.goodsList, function (item, index) {
              return _c("div", { key: index, staticClass: "item" }, [
                _c("div", {
                  staticClass: "pic",
                  style: { backgroundImage: "url(" + item.goods_thumb + ")" },
                }),
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.goods_name)),
                ]),
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticClass: "num" }, [
                    _vm._v(
                      " " + _vm._s(_vm._f("moneyFormat")(item.shop_price)) + " "
                    ),
                  ]),
                  _vm._v(" 点 "),
                ]),
              ])
            }),
          ],
          2
        ),
    _vm.goodsList.length &&
    _vm.value.config.list_show_type === 1 &&
    _vm.value.config.list_show_more === 1
      ? _c("div", { staticClass: "more" }, [_vm._v(" 查看更多 > ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }